module.exports = __webpack_public_path__ + "static/media/leftarrow.b5a6974e.svg";